import { fromJS, List } from 'immutable';
import { combineActions, createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  profiles: List(),
  tempProfileId: null,
  isLoading: false,
});

// const
export const GET_SHOPIFY_PROFILES = 'shopifyProfiles/GET_SHOPIFY_PROFILES';
export const CREATE_SHOPIFY_PROFILE = 'shopifyProfiles/CREATE_SHOPIFY_PROFILE';
export const UPDATE_SHOPIFY_PROFILE = 'shopifyProfiles/UPDATE_SHOPIFY_PROFILE';
export const DELETE_SHOPIFY_PROFILE = 'shopifyProfiles/DELETE_SHOPIFY_PROFILE';

// action creators
export const getShopifyProfiles = createAction(
  GET_SHOPIFY_PROFILES,
  api.shopify.getProfiles,
);
export const createShopifyProfile = createAction(
  CREATE_SHOPIFY_PROFILE,
  api.shopify.createProfile,
);
export const updateShopifyProfile = createAction(
  UPDATE_SHOPIFY_PROFILE,
  (id, data) => api.shopify.updateProfile(id, data),
);
export const deleteShopifyProfile = createAction(
  DELETE_SHOPIFY_PROFILE,
  (data) => ({
    promise: api.shopify.deleteProfile(data.id),
    data,
  }),
);

// reducer
const shopifyProfiles = handleActions(
  {
    [combineActions(
      `${CREATE_SHOPIFY_PROFILE}_REQUEST`,
      `${GET_SHOPIFY_PROFILES}_REQUEST`,
      `${UPDATE_SHOPIFY_PROFILE}_REQUEST`,
    )]: (state) => state.set('isLoading', true),

    [combineActions(
      `${CREATE_SHOPIFY_PROFILE}_ERROR`,
      `${GET_SHOPIFY_PROFILES}_ERROR`,
      `${UPDATE_SHOPIFY_PROFILE}_ERROR`,
      `${DELETE_SHOPIFY_PROFILE}_ERROR`,
    )]: (state) => state.set('isLoading', false),

    [`${DELETE_SHOPIFY_PROFILE}_REQUEST`]: (state, { payload }) =>
      state.set('tempProfileId', payload.id).set('isLoading', true),

    [`${GET_SHOPIFY_PROFILES}_SUCCESS`]: (state, { payload }) => {
      return state.set('profiles', payload.get('data')).set('isLoading', false);
    },

    [`${CREATE_SHOPIFY_PROFILE}_SUCCESS`]: (state, { payload }) =>
      state
        .update('profiles', (profiles) => profiles.push(payload.get('data')))
        .set('isLoading', false),

    [`${UPDATE_SHOPIFY_PROFILE}_SUCCESS`]: (state, { payload }) => {
      const profileId = payload.getIn(['data', 'id']);
      const index = state
        .get('profiles')
        .findIndex((profile) => profile.get('id') === profileId);

      return state
        .setIn(['profiles', index], payload.get('data'))
        .set('isLoading', false);
    },

    [`${DELETE_SHOPIFY_PROFILE}_SUCCESS`]: (state) =>
      state
        .update('profiles', (profiles) =>
          profiles.filter(
            (profile) => profile.get('id') !== state.get('tempProfileId'),
          ),
        )
        .set('tempProfileId', null)
        .set('isLoading', false),
  },
  initialState,
);

export default shopifyProfiles;
